import ApolloClient, { createNetworkInterface} from 'apollo-client';
import * as ajaxRoute from '../constants/ajaxRoutes';
import * as authHandler from '../utils/authHandler';
import * as routes from "../constants/routes";
import {history} from '../constants/common';

const networkInterface = createNetworkInterface({
    uri: ajaxRoute.GRAPHQL_ROUTE,
});

networkInterface.use([{
    applyMiddleware(req, next) {
        if (!req.options.headers) {
            req.options.headers = {};
        }

        if (authHandler.getToken() !== null && authHandler.getToken() !== 'null') {
            req.options.headers['X-Authorization'] = 'Bearer ' + authHandler.getToken();
        }
        next();
    }
}]);

networkInterface.useAfter([
    {
        applyAfterware({response}, next) {
            if (response.status === 401) {
                history.push(routes.LOGOUT);
                return;
            }
            next();
        }
    }
]);

const client = new ApolloClient({
    networkInterface: networkInterface,
    connectToDevTools: true,
});

export default client;


// WEBPACK FOOTER //
// ./src/graphql/client.js